module.exports = __webpack_public_path__ + "static/assets/a37c54185b5bf7aa88dac912d5fc20ef.gif";